var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 680,
    viewBox: "0 0 320 680",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_738_2545)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 680,
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_738_2545)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_738_2545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -208,
    y: -139,
    width: 708,
    height: 868
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7545 -138.888L-207.018 574.726L268.725 728.574L499.497 14.9601L23.7545 -138.888Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_738_2545)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_738_2545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510.182 -94.6818C393.029 -86.1349 273.409 -9.96619 229.459 98.9654C200.364 171.061 198.819 250.909 198.819 328.651C198.818 406.392 207.047 490.957 182.27 564.648C157.494 638.34 104.554 704.837 28.5869 721.353C28.9697 721.729 19.1423 718.352 19.5251 718.728L307.502 811.855L591.758 -64.2552C591.684 -64.0269 588.587 -63.841 588.513 -63.6126L510.17 -94.6754L510.182 -94.6818Z",
    fill: "url(#paint0_linear_738_2545)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_738_2545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-225.051 435.986C-182.607 445.718 -138.606 452.622 -95.5987 445.794C-52.5912 438.966 -10.3021 416.582 11.7886 379.048C32.9667 343.069 33.154 298.42 26.3707 257.225C19.5874 216.029 6.50424 175.854 3.12621 134.236C-0.251813 92.617 7.73524 47.4115 37.0526 17.6904C58.6638 -4.22305 89.0336 -15.0013 118.916 -22.3535C148.798 -29.7056 179.664 -34.4481 207.651 -47.2478C235.646 -60.0445 261.19 -82.8408 267.792 -112.908C285.31 -110.921 306.94 -112.418 324.29 -115.531C320.284 -65.7695 279.961 -29.3813 232.815 -13.6867C198.167 -2.15846 155.847 7.31981 123.451 25.9558C91.9612 44.0651 81.8693 75.3371 77.7058 111.416C69.2241 184.996 107.903 252.261 113.724 324.286C116.962 364.42 114.064 405.165 103.485 444.088C89.0325 497.261 59.5243 546.942 17.7803 583.175C-50.4919 642.454 -149.067 651.334 -235.187 639.448C-238.435 569.705 -233.619 505.281 -225.051 435.986Z",
    fill: "url(#paint1_linear_738_2545)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.733 -120.481C314.727 -70.7192 274.404 -34.331 227.258 -18.6364C192.61 -7.1082 150.29 2.37008 117.894 21.0061C86.4043 39.1154 76.3124 70.3873 72.1489 106.467C63.6672 180.047 102.347 247.311 108.167 319.337C111.405 359.47 108.508 400.215 97.9278 439.138C83.4756 492.311 53.9674 541.992 12.2233 578.225C-56.0583 637.501 -154.642 646.378 -240.754 634.495",
    stroke: "#AFAFAF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-241.201 603.052C-198.288 609.614 -152.519 611.404 -108.765 603.504C-64.9325 595.587 -23.2247 577.503 9.09664 546.683C47.2406 510.305 72.0334 461.653 82.949 410.479C90.9158 372.876 91.884 333.84 88.2769 295.237C87.0977 282.601 85.0689 270.09 82.6201 257.643C72.7272 207.18 56.414 157.364 62.2735 107.655C62.9091 102.375 63.7947 97.1015 64.9206 91.8323C71.8972 59.1115 84.524 31.5706 115.01 15.4278C146.437 -1.1882 186.279 -9.82831 219.392 -21.0961C223.68 -22.5576 227.916 -24.1833 232.071 -25.982C271.063 -42.8842 303.069 -75.0676 307.194 -117.56",
    stroke: "#AFAFAF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-239.76 569.056C-196.939 576.261 -151.527 579.06 -107.917 571.376C-64.2503 563.678 -22.5703 544.608 7.85525 512.565C42.4442 476.13 62.4796 428.41 69.8586 379.235C75.2155 342.942 74.2511 305.625 70.2815 268.566C68.9804 256.437 67.0759 244.386 64.9473 232.379C56.3637 183.685 44.9005 134.796 55.4572 89.0869C56.5995 84.2224 57.9952 79.4189 59.5841 74.6357C69.3485 45.2863 84.526 21.4604 114.015 7.2968C144.477 -7.30877 181.83 -15.1138 213.409 -26.1211C217.47 -27.5301 221.475 -29.0935 225.406 -30.8175C262.199 -46.8967 292.915 -77.2059 297.53 -117.217",
    stroke: "#AFAFAF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-237.371 535.377C-194.64 543.215 -149.582 547.045 -106.125 539.574C-62.6239 532.097 -20.9174 512.1 7.54545 478.781C38.6496 442.365 53.8542 395.51 57.6872 348.331C60.4216 313.355 57.5277 277.747 53.1987 242.222C51.7787 230.59 49.9955 219.01 48.1997 207.436C40.9158 160.508 34.3152 112.54 49.5598 70.8266C51.2116 66.3686 53.108 62.0317 55.1632 57.7567C67.6618 31.7823 85.4531 11.6709 113.948 -0.523022C143.454 -13.115 178.31 -20.0881 208.352 -30.8254C212.175 -32.1848 215.95 -33.6861 219.677 -35.3292C254.269 -50.5854 283.693 -79.0108 288.808 -116.538",
    stroke: "#AFAFAF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-232.125 502.611C-189.492 511.08 -144.786 515.931 -101.482 508.674C-58.1435 501.406 -16.3433 480.567 10.0961 445.9C37.7952 409.581 48.0894 363.514 48.3888 318.324C48.5134 284.659 43.6869 250.769 38.989 216.775C37.4501 205.641 35.785 194.54 34.3125 183.396C28.3349 138.247 26.5873 91.1962 46.5322 53.473C48.6906 49.4311 51.0783 45.5578 53.6153 41.7749C68.8131 19.1538 89.2438 2.77559 116.744 -7.44875C145.285 -18.0303 177.654 -24.1683 206.17 -34.6421C209.76 -35.9614 213.314 -37.3975 216.814 -38.9563C249.206 -53.3895 277.331 -79.9438 282.946 -114.986",
    stroke: "#AFAFAF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-225.938 470.15C-183.394 479.252 -139.042 485.135 -95.8883 478.081C-52.7152 471.033 -10.7293 449.392 13.5977 413.328C37.9903 377.158 43.2786 331.816 40.0414 288.624C37.5436 256.276 30.7875 224.096 25.7397 191.638C24.0884 181.015 22.5382 170.371 21.3858 159.668C16.708 116.283 19.8325 70.1571 44.4526 36.4366C47.1175 32.8107 49.9899 29.3885 53.0249 26.1134C70.8614 6.80488 94.0014 -5.79635 120.495 -14.0446C148.076 -22.6031 177.951 -27.9186 204.93 -38.1225C208.293 -39.3892 211.617 -40.763 214.889 -42.2376C245.085 -55.8573 271.918 -80.5279 278.02 -113.08",
    stroke: "#AFAFAF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-219.713 440.864C-177.268 450.596 -133.268 457.5 -90.2603 450.672C-47.2528 443.844 -4.96376 421.46 17.127 383.927C38.3051 347.947 38.4923 303.299 31.709 262.103C24.9257 220.907 11.8426 180.733 8.46456 139.114C5.09605 97.4986 13.0736 52.29 42.391 22.5689C64.0021 0.655442 94.372 -10.1228 124.254 -17.475C154.136 -24.8271 185.003 -29.5696 212.989 -42.3693C240.985 -55.166 266.528 -77.9623 273.13 -108.03",
    stroke: "#AFAFAF",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_738_2545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.907 -76.2424C327.492 -38.8241 262.092 45.8926 248.013 139.933C233.714 235.436 269.121 330.955 274.493 427.376C281.544 554.062 233.788 682.856 145.86 774.318C147.829 774.955 148.777 774.82 150.746 775.457L265.952 812.713L544.68 -34.8956C541.731 -35.8495 540.284 -36.412 537.334 -37.3659L414.919 -76.2489L414.907 -76.2424Z",
    fill: "url(#paint2_linear_738_2545)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_738_2545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.724 4.21189C432.395 6.8912 385.293 27.8445 350.942 61.9496C316.592 96.0547 295.303 143.002 292.29 191.319C288.757 247.907 309.189 302.797 323.514 357.656C343.701 434.948 352.057 515.318 348.207 595.115L536.366 18.5376C532.849 17.0639 529.891 16.9797 526.374 15.506L480.721 4.22142L480.724 4.21189Z",
    fill: "url(#paint3_linear_738_2545)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.415 9.73788C448.027 11.1369 400.395 30.8364 365.154 64.0229C329.913 97.2094 307.392 143.58 303.097 191.797C298.067 248.269 317.046 303.688 329.91 358.905C348.04 436.708 354.275 517.265 348.315 596.926",
    stroke: "#AFAFAF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.363 23.2867C462.039 23.4139 413.981 41.83 377.956 74.0274C341.922 106.222 318.235 151.91 312.686 199.911C306.189 256.14 323.679 311.939 335.074 367.375C351.139 445.487 355.239 526.047 347.217 605.388",
    stroke: "#AFAFAF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.311 36.8359C476.052 35.6913 427.581 52.8177 390.75 84.0294C353.923 115.231 329.069 160.237 322.275 208.025C314.315 264.002 330.315 320.181 340.239 375.845C354.225 454.273 356.217 534.824 346.121 613.852",
    stroke: "#AFAFAF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.259 50.3852C490.062 47.9781 441.177 63.8148 403.553 94.0343C365.93 124.254 339.912 168.568 331.861 216.149C322.435 271.883 336.946 328.442 345.401 384.324C357.322 463.063 357.188 543.62 345.021 622.324",
    stroke: "#AFAFAF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.206 63.9343C504.073 60.2554 454.772 74.8119 416.355 104.039C377.938 133.266 350.754 176.899 341.448 224.263C330.559 279.744 343.577 336.693 350.564 392.795C360.407 471.849 358.164 552.396 343.916 630.775",
    stroke: "#AFAFAF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.155 77.483C518.083 72.5417 468.369 85.8086 429.149 114.041C389.939 142.276 361.588 185.226 351.028 232.374C338.663 287.609 350.205 344.931 355.72 401.261C363.495 480.634 359.12 561.176 342.81 639.234",
    stroke: "#AFAFAF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.102 91.0319C532.095 84.8188 481.955 96.8024 441.952 124.045C401.948 151.288 372.421 193.553 360.623 240.501C346.794 295.483 356.844 353.195 360.891 409.744C366.59 489.423 360.103 569.965 341.719 647.71",
    stroke: "#AFAFAF",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M554.921 69.4471C506.604 66.4656 457.383 81.7836 419.291 111.663C381.203 141.532 354.586 185.684 345.963 233.311C335.857 289.098 349.752 346.005 357.583 402.159C368.613 481.281 367.551 562.074 354.43 640.869L608.52 90.1539C605.205 88.2831 602.266 87.8477 598.951 85.9769L554.921 69.4471Z",
    fill: "url(#paint4_linear_738_2545)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36.1711 -29.4681C-45.123 25.2207 -44.6908 81.4412 -34.9099 135.987C-27.5829 176.802 -15.055 216.776 -11.6132 258.1C-8.16188 299.427 -15.0616 343.87 -42.0388 375.357C-72.0892 410.432 -125.751 422.842 -168.15 404.518L-47.0637 26.7371C-40.999 7.98335 -39.1998 -9.99529 -36.1711 -29.4681Z",
    fill: "url(#paint5_linear_738_2545)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-47.0733 -28.2219C-59.4202 23.4457 -62.8966 77.2251 -57.3117 130.057C-53.1333 169.59 -43.9213 208.671 -43.4821 248.425C-43.0429 288.178 -52.7094 330.192 -80.6866 358.434C-111.848 389.892 -164.005 398.039 -203.279 377.592L-61.3752 24.7787C-54.2811 7.26173 -51.3193 -9.79443 -47.0763 -28.2124L-47.0733 -28.2219Z",
    fill: "url(#paint6_linear_738_2545)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_738_2545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.495 -147.597C239.517 -126.487 229.467 -109.158 216.984 -92.0706C202.342 -72.0128 174.543 -60.1192 151.491 -52.86C120.562 -43.114 90.684 -45.1985 58.9189 -45.0556C30.996 -44.9313 1.3197 -41.7902 -20.2649 -22.2014C-26.4695 -16.5672 -31.3873 -9.54988 -33.9051 -1.50424L27.651 -198.028L223.275 -134.503C230.768 -135.864 239.487 -141.116 243.495 -147.597Z",
    fill: "#F7F7F7"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_738_2545",
    x: 19.5137,
    y: -106.682,
    width: 592.244,
    height: 926.536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.247059 0 0 0 0 0.247059 0 0 0 0 0.247059 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_738_2545"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_738_2545",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_738_2545",
    x: -247.207,
    y: -122.531,
    width: 580.496,
    height: 779.54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.247059 0 0 0 0 0.247059 0 0 0 0 0.247059 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_738_2545"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_738_2545",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_738_2545",
    x: 134.859,
    y: -83.249,
    width: 418.82,
    height: 908.962,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.247059 0 0 0 0 0.247059 0 0 0 0 0.247059 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_738_2545"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_738_2545",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_738_2545",
    x: 280.887,
    y: -7.78809,
    width: 264.479,
    height: 610.902,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.247059 0 0 0 0 0.247059 0 0 0 0 0.247059 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_738_2545"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_738_2545",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_738_2545",
    x: -44.9043,
    y: -205.028,
    width: 297.4,
    height: 216.524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.247059 0 0 0 0 0.247059 0 0 0 0 0.247059 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_738_2545"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_738_2545",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_738_2545",
    x1: 163.932,
    y1: 765.427,
    x2: 448.526,
    y2: -114.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_738_2545",
    x1: -116.376,
    y1: 677.87,
    x2: 157.628,
    y2: -169.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_738_2545",
    x1: 159.618,
    y1: 778.767,
    x2: 434.314,
    y2: -70.6706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_738_2545",
    x1: 261.65,
    y1: 567.123,
    x2: 448.293,
    y2: -10.0281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_738_2545",
    x1: 271.686,
    y1: 603.014,
    x2: 524.386,
    y2: 51.5892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_738_2545",
    x1: -114.977,
    y1: 422.186,
    x2: 24.7144,
    y2: -9.77864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_738_2545",
    x1: -145.169,
    y1: 397.772,
    x2: -11.1642,
    y2: -16.6095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_738_2545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 680,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_738_2545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 981,
    height: 711,
    fill: "white",
    transform: "translate(-305.678 645.817) rotate(-72.0796)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg3);
export default __webpack_public_path__ + "static/media/bg3.28d12049457fcdeebee47146f389b117.svg";
export { ForwardRef as ReactComponent };